import { AnimatedFigcaption } from 'components/animated-figcaption'
import { TextContainer } from 'components/container'
import TulipSrc from './tulp.webp'
import { GraphicsDescription, GraphicsImage, SmallGraphics } from '../styled'

export const Tulip = () => (
  <TextContainer>
    <SmallGraphics>
      <GraphicsImage src={TulipSrc} alt="" />
      <AnimatedFigcaption
        FigCaptionComponent={GraphicsDescription}
        description="Тюльпан – важный и широко используемый символ в культуре Татарстана. Его также называют цветком Всевышнего."
      />
    </SmallGraphics>
  </TextContainer>
)
